<template>
    <!-- 相关性分析-->
    <div>
        <div class="row-four mb30">策略相关性统计表</div>
        <el-form :model="policyForm" ref="form" class="form-inline" :inline="true">
            <el-form-item label="策略等级" style="margin-right:47px;">
                <el-select v-model="policyForm.leave" style="width:116px" @change="getStrategyList">
                    <el-option label="一级" value="一级"></el-option>
                    <!-- <el-option label="二级" value="二级"></el-option> -->
                </el-select>
            </el-form-item>
            <el-form-item label="开始日期">
                <el-date-picker type="date" placeholder="选择日期" v-model="policyForm.start" :clearable="false" value-format="yyyy-MM-dd" style="width:150px"></el-date-picker>
                <span class="bar">一</span>
            </el-form-item>
            <el-form-item label="结束日期" style="margin-right:76px;">
                <el-date-picker placeholder="选择时间" v-model="policyForm.end" :clearable="false" value-format="yyyy-MM-dd" style="width:150px"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button v-if="inside" type="export" @click="strategyExportOne">数据导出</el-button>
            </el-form-item>
        </el-form>
        <table class="strategy-table mt30" cellspacing="0">
            <tr>
                <th v-for="(head,h) in tabledataOne[0]" :key="h+'h'">{{head}}</th>
                <th @click="add('strategy')"><span>+添加</span></th>
            </tr>
            <tr v-for="(item1,i1) in tabledataOne.slice(1)" :key="i1+'t'">
                <td>{{item1[0]}}</td>
                <td v-for="(item2,i2) in item1.slice(1)" :key="i2+'c'" :style="classObj(item1[i2+1])">{{parseFloat(item1[i2+1]).toFixed(4)}}</td>
                <td><span class="btn-delete" @click="deleteTerm('strategy',item1)"></span></td>
            </tr>
            <tr></tr>
        </table>
        <div class="line"></div>
        <div class="row-four mb30">市场策略相关性统计表</div>
        <el-form :model="marketForm" ref="form" class="form-inline" :inline="true">
            <el-form-item label="策略等级" style="margin-right:47px;">
                <el-select v-model="marketForm.leave" style="width:116px">
                    <el-option label="一级" value="一级"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开始日期">
                <el-date-picker type="date" placeholder="选择日期" v-model="marketForm.start" :clearable="false" value-format="yyyy-MM-dd" style="width:150px"></el-date-picker>
                <span class="bar">一</span>
            </el-form-item>
            <el-form-item label="结束日期" style="margin-right:76px;">
                <el-date-picker placeholder="选择时间" v-model="marketForm.end" :clearable="false" value-format="yyyy-MM-dd" style="width:150px"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button v-if="inside" type="export" @click="strategyExportTwo">数据导出</el-button>
            </el-form-item>
        </el-form>
        <table class="strategy-table mt30" cellspacing="0">
            <tr>
                <th v-if="tabledataTwo.length==0"></th>
                <th v-else v-for="(head,h) in tabledataTwo[0]" :key="h+'h'">{{head}}</th>
                <th @click="add('datum')"><span>+添加</span></th>
            </tr>
            <tr v-for="(item1,i1) in tabledataTwo.slice(1)" :key="i1+'t'">
                <td>{{item1[0]}}</td>
                <td v-for="(item2,i2) in item1.slice(1)" :key="i2+'c'" :style="classObj(item1[i2+1])">{{parseFloat(item1[i2+1]).toFixed(4)}}</td>
                <td><span class="btn-delete" @click="deleteTerm('tactics',item1)"></span></td>
            </tr>
            <tr>
                <td @click="add('tactics')"><span>+添加</span></td>
                <td v-if="tabledataTwo.length==0"></td>
                <td v-else v-for="(delte,d) in tabledataTwo[0].slice(0,-1)" :key="d+'d'"><span class="btn-delete" @click="deleteTerm('datum',tabledataTwo[0][d+1])"></span></td>
            </tr>
        </table>
        <!-- 弹框 -->
        <el-dialog class="strategy-dialog" :visible.sync="dialogVisible" width="398px" :show-close="false">
            <div class="strategy-dialog-tit">添加策略</div>
            <el-select v-if="dialogType=='strategy'" class="mt30" v-model="strategy">
                <el-option :label="item.strategyName" :value="item.innerCode" v-for="(item,i) in strategyArr" :key="i+'c'">
                    <div>{{item.strategyName}}<el-tag v-if="item.innerCode >= 1000500 && item.innerCode <= 1000505">睿选50</el-tag></div>
                </el-option>
            </el-select>
            <el-select v-else-if="dialogType=='tactics'" class="mt30" v-model="tactics">
                <el-option :label="item.strategyName" :value="item.innerCode" v-for="(item,i) in strategyArr" :key="i+'c'">
                    <div>{{item.strategyName}}<el-tag v-if="item.innerCode >= 1000500 && item.innerCode <= 1000505">睿选50</el-tag></div>
                </el-option>
            </el-select>
            <el-select v-else class="mt30" v-model="datum">
                <el-option :label="item.strategyName" :value="item.innerCode" v-for="(item,i) in datumArr" :key="i+'s'"></el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button class="btn" style="background:#61A1BF;" @click="cancal">取 消</el-button>
                <el-button class="btn" @click="addTerm">确认添加</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    const Base64 = require("js-base64").Base64;
    export default {
        name: "strategicAnalysis",
        data() {
            return {
                policyForm: {
                    leave: '',
                    start: '',
                    end: '',
                },
                marketForm: {
                    leave: '',
                    start: '',
                    end: '',
                },
                dialogVisible: false,
                dialogType: '',
                strategy: '',//策略1
                strategyArr: [],
                strategyStr: '1000011,1000012,1000013,',
                tabledataOne: [],
                datum: '',//基准
                datumArr: [],
                datumStr: '1037160,1034945,1037351,',
                tabledataTwo: [],
                tactics: '',//策略2
                tacticsStr: '1000011,1000012,1000013,',
                inside: true,
            }
        },
        watch: {
            policyForm: {
                handler (val) {
                    this.getStrategyRelatedIndex()
                },
                deep: true
            },
            marketForm: {
                handler (val) {
                    this.getMarketRelatedIndex()
                },
                deep: true
            }
        },
        mounted() {
            let key = Base64.decode(this.$commonJs.getCookie('organization'))
            if(key.indexOf('展恒')==-1 && key.indexOf('弘酬')==-1) {
                this.inside = false
            }
            this.policyForm = {
                leave: '一级',
                start: new Date().getFullYear() + '-01-01',
                end: this.$commonJs.timeFormat(new Date(),'yyyy-mm-dd'),
            }
            this.marketForm = {
                leave: '一级',
                start: new Date().getFullYear() + '-01-01',
                end: this.$commonJs.timeFormat(new Date(),'yyyy-mm-dd'),
            }
            this.getStrategyList()
            this.getMarketIndexList()
        },
        methods: {
            getStrategyList() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetStrategyList,{
                    StrategyLevel: vm.policyForm.leave,
                }).then(res => {
                    // console.log(res);
                    this.strategyArr = res.data.data
                }).catch(err => {})
            },
            // 策略相关性统计表
            getStrategyRelatedIndex() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetStrategyRelatedIndex,{
                    StrategyLevel: vm.policyForm.leave,
                    StrategyList: vm.strategyStr,
                    StartDate: vm.policyForm.start,
                    EndDate: vm.policyForm.end,
                }).then(res => {
                    // console.log(res);
                    if(res.data.code == 200) {
                        vm.tabledataOne = res.data.data
                    }
                }).catch(err => {})
            },
            // 基准列表
            getMarketIndexList() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetMarketIndexList,{}).then(res => {
                    // console.log(res);
                    this.datumArr = res.data.data
                }).catch(err => {})
            },
            // 策略基准表
            getMarketRelatedIndex() {
                let vm = this
                vm.$http.post(vm.$apiPath.GetMarketRelatedIndex,{
                    StrategyLevel: vm.marketForm.leave,
                    StrategyList: vm.tacticsStr,//策略代码
                    IndexList: vm.datumStr,//比较基准代码
                    StartDate: vm.marketForm.start,
                    EndDate: vm.marketForm.end,
                }).then(res => {
                    // console.log(res);
                    this.tabledataTwo = res.data.data
                }).catch(err => {})
            },
            add(type) {
                this.dialogType = type
                this.dialogVisible = true
            },
            repeatJudg(str,val) {
                for(let i = 0; i < str.split(',').length; i++) {
                    if(str.split(',')[i] == val) {
                        return true;
                    }
                }
            },
            // 添加策略
            addTerm() {
                let vm = this
                if(vm.dialogType == 'strategy') {//策略相关性统计表
                    if(vm.repeatJudg(vm.strategyStr,vm.strategy)) {return}
                    vm.strategyStr += vm.strategy + ','
                    vm.strategy = ''
                    vm.getStrategyRelatedIndex()
                } else if(vm.dialogType == 'tactics'){//策略2
                    if(vm.repeatJudg(vm.tacticsStr,vm.tactics)) {return}
                    vm.tacticsStr += vm.tactics + ','
                    vm.tactics = ''
                    vm.getMarketRelatedIndex()
                } else if(vm.dialogType == 'datum') {
                    if(vm.repeatJudg(vm.datumStr,vm.datum)) {return}
                    vm.datumStr += vm.datum + ','
                    vm.datum = ''
                    vm.getMarketRelatedIndex()
                }
                vm.dialogVisible = false
            },
            // 删除策略
            deleteTerm(type,val) {
                let vm = this
                let active = (type=='strategy'||type=='tactics')? val[0]+'”该策略' : val+'”该基准'
                vm.$confirm('要删除“'+active+'吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if(type=='strategy') {//策略相关性统计表
                        const object = vm.strategyArr.find(item => item.strategyName == val[0])
                        let strArr1 = vm.strategyStr.split(',')
                        const i1 = strArr1.findIndex(item => item == object.innerCode)
                        strArr1.splice(i1, 1)
                        vm.strategyStr = strArr1.join(',')
                        console.log(vm.strategyStr);
                        vm.getStrategyRelatedIndex()
                    } else if(type=='tactics'){//策略2
                        const object = vm.strategyArr.find(item => item.strategyName == val[0])
                        let strArr2 = vm.tacticsStr.split(',')
                        const i2 = strArr2.findIndex(item => item == object.innerCode)
                        strArr2.splice(i2, 1)
                        vm.tacticsStr = strArr2.join(',')
                        vm.getMarketRelatedIndex()
                    } else {
                        const object = vm.datumArr.find(item => item.strategyName == val)
                        let strArr3 = vm.datumStr.split(',')
                        const i3 = strArr3.findIndex(item => item == object.innerCode)
                        strArr3.splice(i3, 1)
                        vm.datumStr = strArr3.join(',')
                        vm.getMarketRelatedIndex()
                    }
                    vm.$message.success('删除成功!')
                }).catch(err=>{})
            },
            cancal() {
                let vm = this
                vm.strategy = ''
                vm.tactics = ''
                vm.datum = ''
                vm.dialogVisible = false
            },
            strategyExportOne() {
                let vm = this
                vm.$http.post(vm.$apiPath.ExportStrategyRelatedValue,{
                    StrategyLevel: vm.policyForm.leave,             
                    StrategyList: vm.strategyStr, //策略代码  
                    StartDate: vm.policyForm.start,
                    EndDate: vm.policyForm.end,
                }).then(res=>{
                    // 转化为blob对象
                    let blob = this.buildBlobByByte(res.data.data.value);
                    let filename = res.data.data.name;
                    this.downloadFile(blob, filename);
                    this.$message({
                        message: "导出成功~",
                        type: "success",
                    });
                })
            },
            strategyExportTwo() {
                let vm = this
                vm.$http.post(vm.$apiPath.ExportMarketRelatedValue,{
                    StrategyLevel: vm.marketForm.leave,             
                    StrategyList: vm.tacticsStr, //策略代码 
                    IndexList: vm.datumStr, //比较基准代码 
                    StartDate: vm.marketForm.start,
                    EndDate: vm.marketForm.end,
                }).then(res=>{
                    // 转化为blob对象
                    let blob = this.buildBlobByByte(res.data.data.value);
                    let filename = res.data.data.name;
                    this.downloadFile(blob, filename);
                    this.$message({
                        message: "导出成功~",
                        type: "success",
                    });
                })
            },
            downloadFile: function(blob, fileName) {
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = fileName
                // 此写法兼容可火狐浏览器
                document.body.appendChild(link)
                const evt = document.createEvent('MouseEvents')
                evt.initEvent('click', false, false)
                link.dispatchEvent(evt)
                document.body.removeChild(link)
            },
            buildBlobByByte: function(data) {
                const raw = window.atob(data)
                const rawLength = raw.length
                const uInt8Array = new Uint8Array(rawLength)
                for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i)
                }
                return new Blob([uInt8Array])
            },
            
        },
        computed: {
            classObj(state) {
                // console.log(state);
                return (state) => {
                    if(state >= -1 && state < -0.6) {
                        return { background: '#95B8C9' }
                    } else if(state >= -0.6 && state < -0.3) {
                        return { background: '#80AABF' }
                    } else if(state >= -0.3 && state < 0) {
                        return { background: '#679AB2' }
                    } else if(state >= 0 && state < 0.3) {
                        return { background: '#4D88A5' }
                    } else if(state >= 0.3 && state < 0.6) {
                        return { background: '#1A678C' }
                    } else if(state >= 0.6 && state <= 1) {
                        return { background: '#024B6E' }
                    }
                }
            },
        }
    }
</script>

<style scoped lang="less">
.line {width: 100%;margin: 54px 0;border: 1px dashed @colorc;}
/* 添加对话框 */ 
.strategy-dialog {
    /deep/.el-dialog {border-radius: 10px;text-align: center;}
    /deep/.el-dialog__header {padding: 0;}
    &-tit {font-size: 18px;color: @color3;}
    /deep/.el-input--suffix .el-input__inner {width: 278px;height: 36px;border: 1px solid @mainColor;border-radius: 18px;color: @mainColor;text-align: center;}
    /deep/.el-input__suffix .el-input__suffix-inner .el-select__caret:before {
        content: "";
        background: url(../../assets/images/select_down_b.png) center center no-repeat;
        position: absolute;
        width: 100%;
        height: 100%;
        transform: rotate(180deg);
        top: 0%;
        right: 0%;
    }
    /deep/.el-dialog__footer {
        padding: 0 55px 44px;
        .dialog-footer {display: flex;justify-content: space-between;}
    }
    .btn {width: 128px;height: 36px;background: @mainColor;border-radius: 18px;color: @whiteColor;padding: 0;}
}
.el-tag {
    margin-left: 10px;
    padding: 0 5px;
    height: 18px;
    line-height: 18px;
    font-size: 12px;
}
</style>